import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';

import * as $ from 'jquery'

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

	@Input() pageObj1: string;
	@Input() pageObj2: string;
	@Input() pageObj3: string;
	@Input() pageObj4: string;
	@Input() pageObj5: string;
	@Input() pageObj6: string;
	@Input() pageObj7: string;

	autoOrder:any;

	logi_user:any;
	orderUserCnt:number = 0;

	constructor(
		private http: HttpClient,
		private env: EnvService,
		private authService: AuthService,
	) { }

	ngOnInit() {
		this.orderLatestCnt();

		this.autoOrder = setInterval(() => {
			//this.orderLatestCnt();
		}, 3000);
	}

	async orderLatestCnt() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/order.cnt_user.php', formData).subscribe((response) => {
			this.orderUserCnt = response['cnt'];
		});
	}

}
